import { useState } from "react";

export function Loading({ message = "Подключение..." }: { message?: string }) {
  const [splashFailed, setSplashFailed] = useState(false);
  return (
    <div className="relative flex h-full items-center justify-center overflow-hidden">
      {!splashFailed && (
        <img
          src="/icons/splash.png"
          alt=""
          className="absolute inset-0 h-full w-full object-cover opacity-40"
          onError={() => setSplashFailed(true)}
        />
      )}
      <div className="relative z-10 text-center">
        <div className="mb-4 text-5xl drop-shadow-lg">⚔️</div>
        <div className="text-tg-text drop-shadow-md">{message}</div>
      </div>
    </div>
  );
}
